import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import { MAX_WR_TRUCK_EQUIPMENT_ADDITIONAL_FIELDS } from 'ab-common/constants/value';

import AdditionalField from './AdditionalField';
import type { AdditionalTrucksEquipmentField } from '../../../formModel';
import styles from '../../../styles.module.scss';

type Props = WrappedFieldArrayProps<AdditionalTrucksEquipmentField>;

const AdditionalTrucksAndEquipment: React.FC<Props> = (props) => {
	const { fields } = props;

	const onAddClick = React.useCallback(() => {
		fields.push({ isChecked: false, name: '' });
	}, [fields]);

	const onRemoveClick = React.useCallback((index: number) => () => fields.remove(index), [fields]);

	const renderAdditionalField = React.useCallback((_af: string, _index: number) => {
		return <AdditionalField fieldName={_af} onRemoveClick={onRemoveClick(_index)} />;
	}, [onRemoveClick]);

	return <>
		{fields.map(renderAdditionalField)}
		{fields.length < MAX_WR_TRUCK_EQUIPMENT_ADDITIONAL_FIELDS && (
			<div
				className={styles['job-form__add-field-button']}
				onClick={onAddClick}
			>
				<span className="icon-plus" />
				<span>
					Add
				</span>
			</div>)
		}
	</>;
};

export default React.memo(AdditionalTrucksAndEquipment);
